/*
 * Copyright Mimic Networks, Inc. 2026.
 */

// Accept URLs with or without protocol, including localhost, internal hostnames, and long TLDs
// Case-insensitive for protocol/hostname; allows underscores (common in internal environments)
export const redirectUriPattern =
  /^(https?:\/\/)?([a-zA-Z0-9][-a-zA-Z0-9_]*(\.[a-zA-Z0-9][-a-zA-Z0-9_]*)*|localhost)(:[0-9]{1,5})?(\/[-a-zA-Z0-9@:%_+.~#?&/=]*)?$/i;

export function isValidRedirectUri(uri: string): boolean {
  return redirectUriPattern.test(uri);
}
